import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface AdminStats {
  totalRequests: number
  byStatus: Record<string, number>
  byDirection: Record<string, number>
  totalVolume: string
  totalVolumeFormatted: string
  totalFees: string
  totalFeesFormatted: string
  volume24h: string
  volume24hFormatted: string
  volume7d: string
  volume7dFormatted: string
  contractStats: {
    lockCounter: number
    totalActiveLocks: string
    totalFeesCollected: string
    totalProcessed: string
    totalReleased: string
    contractBalance: string
    isPaused: boolean
  }
}

export function useAdminStats() {
  const { data: stats, isLoading, error, refetch } = useQuery<AdminStats>({
    queryKey: ['adminStats'],
    queryFn: () => api.getAdminStats(),
    retry: 1,
    staleTime: 30000,
    refetchInterval: 60000, // Auto refresh every minute
  })

  return {
    stats,
    isLoading,
    error,
    refetch,
  }
}
